import React from "react";
import { ProductMasthead } from "components/templates/ProductPage/ProductPageMasthead";
import { IProduct } from "interfaces/product.interface";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import { IVTEmbedDemo } from "components/molecules/IVTEmbedDemo";

export const InstantValuationToolMasthead = ({
  product,
}: {
  product: IProduct;
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="xl">
          <ModalBody p={12}>
            <IVTEmbedDemo />
          </ModalBody>
        </ModalContent>
      </Modal>

      <ProductMasthead
        product={product}
        onDemoButtonClick={onOpen}
        cover={"/images/illustrations/case-study-1.png"}
        hasVideo={true}
      />
    </>
  );
};
